import React from 'react';

const Matrices = () => {
    return (
        <div>Matrices Component</div>
    );
}

export default Matrices;
